import React from "react";
import Icon from "@mdi/react";
import { mdiArrowRight, mdiChevronRight } from "@mdi/js";
import { Link } from "react-router-dom";
import ScrollCarousel from "./ScrollCarousel";
import useBreakpoint from "../../../../utils/useBreakpoint";
import { DESTINATIONS } from "../mock";
import type { TravelMode } from "../Homepage";

interface Props {
  mode?: TravelMode;
}

// Luggage-tag style capsule destination cards on a sky-blue rounded panel, with a
// trailing "see more" tag. In cruise mode the title switches to "Popular Right Now"
// (two-tone) per Figma. On desktop the cards sit in a grid; on mobile they move
// into the shared horizontal scroll-snap carousel (a single scrollable row).
export default function ExploreDestinations({ mode = "tour" }: Props) {
  const isCruise = mode === "cruise";
  const isMobile = useBreakpoint();

  const cards = [
    ...DESTINATIONS.map((d) => (
      <div key={d.id} className="v2-tag-card">
        <div className="v2-tag-card__frame">
          <div className="v2-tag-card__photo">
            <span className="v2-tag-card__img" style={{ backgroundImage: `url(${d.image})` }} aria-hidden="true" />
            <span className="v2-tag-card__strap" aria-hidden="true" />
            <span className="v2-tag-card__label">{d.name}</span>
          </div>
        </div>
      </div>
    )),
    <Link key="more" to="/web" className="v2-tag-card v2-tag-card--more">
      <div className="v2-tag-card__frame">
        <div className="v2-tag-card__photo v2-tag-card__photo--more">
          <span className="v2-tag-card__img" style={{ backgroundImage: `url(/iceholidays-assets/images/destinations/more.png)` }} aria-hidden="true" />
          <span className="v2-tag-card__strap" aria-hidden="true" />
          <span className="v2-tag-card__more-btn" aria-hidden="true">
            <Icon path={mdiArrowRight} size="22px" />
          </span>
          <span className="v2-tag-card__more-label">More</span>
        </div>
      </div>
    </Link>,
  ];

  return (
    <section id="explore-destinations-v2">
      <div className="v2-explore__panel">
        <div className="v2-explore__header">
          <div>
            <h2 className="v2-section__title">
              {isCruise ? (
                <>
                  <span className="v2-explore__title-accent">Popular</span> Right Now
                </>
              ) : (
                "Explore More Destinations"
              )}
            </h2>
            <p className="v2-section__subtitle">What other travellers are booking</p>
          </div>
          {/* Mobile-only: the trailing "More" card sits off-screen in the carousel,
              so surface a header "View all" to match the other sections. */}
          <Link to="/web" className="v2-section__viewall">
            View all <Icon path={mdiChevronRight} size="20px" />
          </Link>
        </div>

        {isMobile ? (
          <ScrollCarousel trackClassName="v2-explore__track" step={166}>
            {cards}
          </ScrollCarousel>
        ) : (
          <div className="v2-explore__grid">{cards}</div>
        )}
      </div>
    </section>
  );
}
